/**
 * 资讯
 */
 import React, { useEffect, useState } from "react"
 import { LoadStatus } from "../../load_status"
 import stock_info from "../../../../modules/stock_info/newweb"
 import { quotedata } from "../../quotedata"

 export function StockInfo(props: { quotedata: quotedata }) {
   const [stockInfo, setStockInfo] = useState([])
   const [currentPageStockInfo, setCurrentPageStockInfo] = useState([])
   const [loading, setLoading] = useState(false)
   const [pageNumber, setPageNumber] = useState(1)
 
   const openDetail = (infoId: string, Dst:string) => {
    if(Dst == 'CFH'){
     location.href = `https://emcreative.eastmoney.com/app_fortune/article/index.html?artcode=${infoId}`
    }
    else{
     location.href = "https://wap.eastmoney.com/a/" + infoId + ".html"
    }
   }
   const loadMore = () => {
     setPageNumber(pageNumber+1)
   }
 
   const getStockInfo = () => {
     const CHOICE_ZS = 47
     setLoading(true)
 
     if (props.quotedata.market == CHOICE_ZS) {
       props.quotedata.code = "000001"
       props.quotedata.market = 1
     }
 
     stock_info.getStockInfos(props.quotedata.code, props.quotedata.market, pageNumber, 20).then((back: any) => {
       if (back && back.length) {
         if (pageNumber == 1) {
           setStockInfo(back)
         } else {
           let temp = stockInfo.concat(back)
           setStockInfo(temp)
         }
         setCurrentPageStockInfo(back)
         setLoading(false)
       }else{
        setCurrentPageStockInfo([])
        setLoading(false)
       }
     })
   }
 
   useEffect(() => {
     getStockInfo()
   }, [pageNumber])
 
   return (
     <>
       <ul className="report-list">
         {stockInfo.length > 0 && stockInfo.map((item: any) => {
           return (
             <li key={item.Art_Code}>
               <a>
                 <div className="tit" onClick={() => openDetail(item.Art_Code, item.Art_Dst)}>
                   {item.Art_Title}
                 </div>
                 <p className="time">{item.Art_ShowTime.substring(0, 10)}</p>
               </a>
             </li>
           )
         })}
       </ul>
       {loading && <LoadStatus icon={true} title="数据加载中..." className="com_tips" />}
       {!loading && stockInfo.length == 0 && <LoadStatus icon={false} title="暂无数据" className="com_tips" />}
       {stockInfo.length > 0 && currentPageStockInfo.length < 20 && <LoadStatus icon={false} title="到底了" className="com_tips" />}
       {currentPageStockInfo.length == 20 && (
         <div
           className="comm-more"
           onClick={(e) => {
             e.preventDefault()
             loadMore()
           }}
         >
           <a href="#">加载更多</a>
         </div>
       )}
     </>
   )
 }